/**
 * Created by piotr.pozniak@thebeaverhead.com on 16/02/2026
 */

import React, { useMemo } from "react";
import WebsiteMissingWarning from "../../WebsiteMissingWarning";
import WebsitesVerifiedInfo from "../../WebsiteVerifiedInfo";
import InstallAccordion from "../../InstallAccordion";
import ClipboardCopyInput from "../../../../component/ClipboardCopyInput";
import FeatureFlag from "../../../../component/FeatureFlag";
import {
  getInstallDivTag,
  installScripTag,
} from "../../../../templates/WidgetPageTemplate/InstallTab/helpers";

const WordPressInstructionsPlugin = ({
  uuid,
  slug,
  widgetType,
  widgetTypePrintable,
  onGoToAddWebsite,
  widgetTemplate,
}) => {
  return (
    <div>
      <div className={"my-4"}>
        <WebsiteMissingWarning onAddWebsite={onGoToAddWebsite} />
        <WebsitesVerifiedInfo />
      </div>
      <InstallAccordion
        title={"Recommended installation"}
        defaultExpanded={true}
        expandable={false}
      >
        <ol>
          <li>
            In your WordPress admin, go to <strong>Plugins</strong> →{" "}
            <strong>Add New</strong>, search for "<strong>Revisual</strong>", or
            install directly from{" "}
            <a
              href={"https://wordpress.org/plugins/revisual/"}
              target={"_wp_revisual_plugin"}
            >
              WordPress.org{" "}
              <span className={"material-icons icon-xs"}>open_in_new</span>
            </a>
            , then activate the plugin.
          </li>
          <li>
            Open the <strong>Revisual</strong> menu and log in to connect your
            site — this will automatically handle authorization.
          </li>
          <li>
            Once connected, select the widget to embed. You can use a shortcode
            or the Gutenberg block.
          </li>
        </ol>
        <p>
          No additional setup is required — the plugin handles everything
          automatically.
        </p>
      </InstallAccordion>
    </div>
  );
};

export default WordPressInstructionsPlugin;
